export const props = {
  data: {
    type: Array,
    default: () => [],
  },
  headers: {
    type: Array,
    required: true,
  },
  permission: {
    type: String,
    required: true,
  },
  fontSize: {
    type: Number,
    required: false,
    default: 14,
  },
}
